var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"modal-close",attrs:{"data-cy":"btn-close-modal"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('SvgIcon',{staticClass:"tw-w-5 tw-h-5 tw-text-gray-555",attrs:{"name":"close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }